"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoContainer = exports.List = exports.OpenDrawerIcon = exports.Drawer = exports.Container = exports.DRAWER_LIST_MARGIN_BOTTOM = exports.DRAWER_LIST_MARGIN_TOP = exports.LOGO_MARGIN_TOP = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const global_variables_1 = require("../../../core/global.variables");
exports.LOGO_MARGIN_TOP = 16;
exports.DRAWER_LIST_MARGIN_TOP = 24;
exports.DRAWER_LIST_MARGIN_BOTTOM = 40;
exports.Container = styled_components_1.default.div `
  display: flex;
`;
exports.Drawer = (0, styled_components_1.default)(({ className, ...props }) => ((0, jsx_runtime_1.jsx)(material_1.Drawer, { classes: { root: className }, ...props })))(({ $isDrawerOpen }) => (0, styled_components_1.css) `
    width: ${$isDrawerOpen ? global_variables_1.DRAWER_OPEN_WIDTH : global_variables_1.DRAWER_CLOSE_WIDTH}px;
    flex-shrink: 0;
    white-space: nowrap;
    overflow-y: visible;

    & .MuiDrawer-paper {
      width: ${$isDrawerOpen ? global_variables_1.DRAWER_OPEN_WIDTH : global_variables_1.DRAWER_CLOSE_WIDTH}px;
      flex-shrink: 0;
      white-space: nowrap;
      transition: 0.2s linear;
      overflow-y: visible;
    }
  `);
exports.OpenDrawerIcon = styled_components_1.default.span(({ $isDrawerOpen }) => (0, styled_components_1.css) `
    position: absolute;
    top: 16px;
    left: ${$isDrawerOpen ? '100%' : '50%'};
    transform: translateX(-50%);
    transition: 0.2s ease-out;
    z-index: 3100;
    cursor: pointer;
  `);
exports.List = (0, styled_components_1.default)(material_1.List) `
  margin: ${exports.DRAWER_LIST_MARGIN_TOP}px 10px ${exports.DRAWER_LIST_MARGIN_BOTTOM}px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
exports.LogoContainer = styled_components_1.default.div(({ $isDrawerOpen }) => (0, styled_components_1.css) `
    opacity: ${$isDrawerOpen ? 1 : 0};
    transition: ${$isDrawerOpen ? 0.6 : 0}s ease-in;
    margin: ${exports.LOGO_MARGIN_TOP}px 0 0 12px;
    cursor: default;
    pointer-events: ${$isDrawerOpen ? undefined : 'none'};
  `);
